export const TYPES = {
    success: 'success',
    warning: 'warning',
    error: 'error',
    info: 'info',
    base: 'base',
};

export const POSITION = {
    topLeft: 'top-left',
    topCenter: 'top-center',
    topRight: 'top-right',
    bottomLeft: 'bottom-left',
    bottomCenter: 'bottom-center',
    bottomRight: 'bottom-right',
};

const POSITIONS_TOP = [POSITION['topLeft'], POSITION['topCenter'], POSITION['topRight']];
